import React, { useEffect, useState } from 'react';
import history from '../../../history';

import './index.css';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { MenuState } from '../../../store/reducers/menuReducer';
import { UserState } from '../../../store/reducers/userReducer';

import LcIconLink from '../../Generic/LcIconLink';
import LcDropDown from '../../Generic/LcDropDown';

//MSAL
import { authProvider } from '../../../services/authProvider';
import { TopMenu } from '../TopMenu/Index';
import { Period } from "../../../models/Period";


interface Props {
    pageTitle?: string,
    topMenuUpdate?: string,
    topMenuSelection?: {
        selections: Period[],
        onChange: Function
    },
    topMenuTutorials: boolean
}

const MobileMenu: React.FC<Props> = (props) => {

    const dispatch = useDispatch();
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);

    //#region Notificações
    const [notificationsBadge, setNotificationsBadge] = useState<number>(0);


    useEffect(() => {

    }, [user.nickName])
    //#endregion

    return (
        <div className={`mobilemenu mobile-only`}>
            <div className="content">
                <div className="left">
                    <i className="ppi ppi-menu link" onClick={() => { dispatch({ type: 'MENU_TOGGLE', payload: !menu.toggle }); }} />
                    <span className="title">{props.pageTitle}</span>
                </div>
                {
                    window.screen.width < 600
                        ? <TopMenu
                            pageTitle={props.pageTitle}
                            lastUpdate={props.topMenuUpdate}
                            selection={props.topMenuSelection}
                            showTutorials={props.topMenuTutorials}
                        />

                        : <div className="right">
                            <LcDropDown element={<LcIconLink icon="ppi ppi-dots-vertical" />} position="right">
                                {
                                    /* <span className="item">Minhas informações</span>
                                    <span className="item">Ajuda</span>
                                    <span className="item">Sobre</span> */
                                }
                                <span className="item" onClick={() => authProvider.LogOutMSSO()}>Sair</span>
                            </LcDropDown>
                        </div>
                }
            </div>
        </div>
    );
}

export default MobileMenu;